import {OrganizationRoleCapability} from "~/enums/roles/capabilities/organizationRoleCapability";
import User from "~/models/user";
import UserDecorator from "../../formability/admin/models/userDecorator";
import ProcessFlow from "~/models/processFlows/processFlow";
import BaseCan from "~/abilities/baseCan";
import {DocumentRoleCapability} from '~/enums/roles/capabilities/documentRoleCapability'
import {IProcessFlow} from '~/interfaces/processFlowInterfaces'
import {ICapable} from '~/interfaces/capableInterfaces'

export default class ProcessFlowCan extends BaseCan {
  constructor(user: User | UserDecorator) {
    // Process Flow abilities based on object model abilities as of now
    super(user);

    const processFlowClasses = [ProcessFlow];

    this.iCan(['viewContextMenu'], processFlowClasses, processFlow => {
      if (processFlow.isArchive) return;

      return user.hasOrganizationCapability(OrganizationRoleCapability.manageObjectModels) ||
        processFlow.hasShareCapability(user, DocumentRoleCapability.editModeling);
    })

    this.iCan(['manage', 'edit', 'moveArchive'], processFlowClasses, processFlow => {
      return user.hasOrganizationCapability(OrganizationRoleCapability.manageObjectModels);
    });

    this.iCan(['edit'], processFlowClasses, processFlow => {
      return processFlow.hasShareCapability(user, DocumentRoleCapability.editModeling);
    });

    this.iCan(['debug'], processFlowClasses, (processFlow: ICapable) => {
      return processFlow.hasShareCapability(user, DocumentRoleCapability.debugProcessFlows);
    });
  }
}